<template>
  <base-modal
    :width="420"
    :title="'Delete your account'"
    @closeModal="onCloseModal"
  >
    <div class="wrapper">
      <p class="mt-4">
        Please check both boxes below to proceed with the deletion of your
        account:
      </p>
      <div class="row no-border">
        <div class="checkbox">
          <input
            id="data-delete"
            type="checkbox"
            :checked="deleteDataChecked"
            @click="deleteDataChecked = !deleteDataChecked"
          />
          <label for="data-delete">
            <div>
              I understand that all my project and user data will be gone
              forever
            </div>
          </label>
        </div>
        <div class="checkbox">
          <input
            id="stripe-delete"
            type="checkbox"
            :checked="deleteStripeChecked"
            @click="deleteStripeChecked = !deleteStripeChecked"
          />
          <label for="stripe-delete">
            <div>
              I understand that any paid subscriptions I have will be canceled
              immediately
            </div>
          </label>
        </div>
      </div>
      <div class="buttons">
        <button
          :disabled="!deleteDataChecked || !deleteStripeChecked"
          class="confirm"
          @click="onConfirm"
        >
          Yes, delete my account
        </button>
        <button class="cancel" @click="onCloseModal">
          Cancel
        </button>
      </div>
    </div>
  </base-modal>
</template>

<script>
import requests from '../../../vuex/requests.js';
import BaseModal from '@components/modals/BaseModal.vue';

export default {
  components: {
    BaseModal,
  },
  data() {
    return {
      deleteDataChecked: false,
      deleteStripeChecked: false,
    };
  },
  mounted() {
    $(this.$el)
      .find('#name')
      .focus();
  },

  methods: {
    onConfirm() {
      if (this.deleteDataChecked && this.deleteStripeChecked) {
        requests.account.deleteAccount().then(response => {
          console.log('Account succesfully deleted, redirecting');
          window.location = '/';
          this.$emit('closeModal');
        });
      }
    },

    onCloseModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 0 20px 20px 20px;
  .checkbox {
    margin: 20px 0;
    label div {
      padding: 0 0 0 35px;
      font-size: 14px;
      font-weight: 600;
      line-height: 150%;
      user-select: none;
      color: #fcfcfc;
    }
    input[type='checkbox'] {
      position: absolute;
      opacity: 0;

      & + label {
        cursor: pointer;
        position: relative;
        border-radius: 3px;
      }

      & + label:before {
        content: '';
        margin-right: 10px;
        display: inline-block;
        vertical-align: text-top;
        width: 20px;
        height: 20px;
        background: #2c3233;
        border-radius: 3px;
        border: 1px solid #696d6d;
        position: absolute;
      }

      &:checked + label:before {
        background: #db841e;
        border: 1px solid transparent;
      }

      &:checked + label:after {
        content: '';
        position: absolute;
        left: 5px;
        top: 9px;
        background: white;
        width: 2px;
        height: 2px;
        box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white,
          4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
        transform: rotate(45deg);
      }
    }
  }
  .buttons {
    display: flex;
    justify-content: flex-end;

    button {
      padding: 8px 12px;
      border-radius: 3px;
      display: inline-block;
      color: #fff;
      cursor: pointer;
      margin: 25px 0 0 20px;
      font-size: 15px;

      &.confirm {
        background: #ab1f1f;
        border: none;
        &:disabled {
          background: #40494a !important;
          color: #aaa;
        }

        &:hover {
          background: #d02020;
        }
      }

      &.cancel {
        border: 1px solid #6e797b;
        background: #2c3233;

        &:hover {
          background: #464b4c;
        }
      }
    }
  }
}
</style>
